import type { ColorName } from '@tunasong/schemas'
import { materialColors, type ColorShade } from './material-colors.js'

const colors = [
  'amber',
  'blue',
  'blueGrey',
  'brown',
  'cyan',
  'deepOrange',
  'deepPurple',
  'green',
  'grey',
  'indigo',
  'lightBlue',
  'lightGreen',
  'lime',
  'orange',
  'pink',
  'purple',
  'red',
  'teal',
  'yellow',
]

const excludeColors = ['grey', 'blueGrey']

export const colorNames = colors
  .filter(c => !excludeColors.includes(c))
  .sort()
  .reverse() as readonly ColorName[]

/** Get color value from color name */
export const getColorCSS = (colorName?: ColorName, intensity: ColorShade = 500) =>
  colorName ? materialColors[colorName][intensity] : 'inherit'
